module.exports = __webpack_public_path__ + "static/media/php.6054cb97.svg";